import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", name: "login", component: () => import("@/views/LoginView.vue"), meta: { public: true } },
    { path: "/forgot-password", name: "forgot-password", component: () => import("@/views/ForgotPasswordView.vue"), meta: { public: true } },
    { path: "/reset-password", name: "reset-password", component: () => import("@/views/ResetPasswordView.vue"), meta: { public: true } },

    // Authenticated app
    { path: "/", redirect: "/dashboard" },
    { path: "/dashboard", name: "dashboard", component: () => import("@/views/DashboardView.vue"), meta: { title: "概覽" } },

    { path: "/pages", name: "pages", component: () => import("@/views/PageListView.vue"), meta: { title: "頁面" } },
    { path: "/pages/new", name: "page-new", component: () => import("@/views/PageEditView.vue"), props: { id: null }, meta: { title: "新增頁面" } },
    { path: "/pages/:id(\\d+)", name: "page-edit", component: () => import("@/views/PageEditView.vue"), props: (r) => ({ id: Number(r.params.id) }), meta: { title: "編輯頁面" } },
    { path: "/pages/:id(\\d+)/builder", name: "page-builder", component: () => import("@/views/PageBuilderView.vue"), props: (r) => ({ id: Number(r.params.id) }), meta: { title: "版面編輯器", fullscreen: true } },

    { path: "/footer", name: "footer", component: () => import("@/views/FooterEditView.vue"), meta: { title: "頁尾" } },
    { path: "/footer/builder", name: "footer-builder", component: () => import("@/views/FooterBuilderView.vue"), meta: { title: "頁尾編輯器", fullscreen: true } },

    { path: "/events", name: "events", component: () => import("@/views/EventListView.vue"), meta: { title: "活動" } },
    { path: "/events/new", name: "event-new", component: () => import("@/views/EventEditView.vue"), props: { id: null }, meta: { title: "新增活動" } },
    { path: "/events/:id(\\d+)", name: "event-edit", component: () => import("@/views/EventEditView.vue"), props: (r) => ({ id: Number(r.params.id) }), meta: { title: "編輯活動" } },

    { path: "/media", name: "media", component: () => import("@/views/MediaListView.vue"), meta: { title: "媒體報導" } },
    { path: "/media/new", name: "media-new", component: () => import("@/views/MediaEditView.vue"), props: { id: null }, meta: { title: "新增報導" } },
    { path: "/media/:id(\\d+)", name: "media-edit", component: () => import("@/views/MediaEditView.vue"), props: (r) => ({ id: Number(r.params.id) }), meta: { title: "編輯報導" } },

    { path: "/documents", name: "documents", component: () => import("@/views/DocumentListView.vue"), meta: { title: "公眾查閱" } },

    { path: "/submissions", name: "submissions", component: () => import("@/views/SubmissionsView.vue"), meta: { title: "聯絡訊息" } },

    { path: "/settings", name: "settings", component: () => import("@/views/SettingsView.vue"), meta: { title: "系統設定" } },

    { path: "/account", name: "account", component: () => import("@/views/AccountView.vue"), meta: { title: "帳戶" } },

    // Image library is now managed inline via the ImagePicker — keep a redirect for bookmarks.
    { path: "/images", redirect: "/dashboard" },

    { path: "/:rest(.*)*", name: "not-found", component: () => import("@/views/NotFoundView.vue") },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.ready) await auth.refresh();
  if (to.meta.public) {
    if (auth.user && to.name === "login") return { name: "dashboard" };
    return true;
  }
  if (!auth.user) {
    return { name: "login", query: { next: to.fullPath } };
  }
  return true;
});

export default router;
